import TabViewController from './TabViewController';

export default TabViewController;
